import axios from '@/utils/api'; // eslint-disable-line

const actions = {
  // eslint-disable-next-line no-unused-vars
  async cadastrarUsuario({ commit }, { usuario, isExterno }) {
    const data = await axios({
      method: 'post',
      data: usuario,
      url: isExterno ? 'usuarios/publico/create' : 'usuarios/create',
    });
    return data;
  },

  // eslint-disable-next-line no-unused-vars
  async findEmailByCpfCnpj({ commit }, cpfCnpj) {
    console.log(cpfCnpj);
    const data = await axios({
      method: 'get',
      url: `usuarios/publico/findEmailByCpfCnpj/` + cpfCnpj,
    });
    return data;
  },

  // eslint-disable-next-line no-unused-vars
  async requestRedefinirSenha({ commit }, info) {
    const request = info.email ? `${info.cpfCnpj}/${info.email}` : info.cpfCnpj;
    const data = await axios({
      method: 'post',
      url: `usuarios/publico/redefinirSenha/` + request,
    });
    return data;
  },

  // eslint-disable-next-line no-unused-vars
  async redefinirSenha({ commit }, dto) {
    const data = await axios({
      method: 'post',
      data: dto,
      url: `usuarios/publico/redefinirSenha`,
    });
    return data;
  },

  // eslint-disable-next-line no-unused-vars
  async findUsuarioByCpfCnpj({ commit }, cpfCnpj) {
    const data = await axios({
      method: 'get',
      url: 'usuarios/publico/findByCpfCnpj',
      params: {
        cpfCnpj,
      },
    });
    return data;
  },
};

export default {
  namespaced: true,
  actions,
};
